import React from 'react';
import { Link } from 'react-router-dom';
import { TestSet } from '../../types/models';
import './AvailableTestsList.css'; // Dodamy proste style

type AvailableTestsListProps = {
  testSets: TestSet[];
};

export const AvailableTestsList = ({ testSets }: AvailableTestsListProps) => {
  if (testSets.length === 0) {
    return <p>Instruktor nie przygotował jeszcze żadnych testów.</p>;
  }

  return (
    <div className="test-list-container">
      <h2>Dostępne testy</h2>
      {testSets.map((set) => (
        <div key={set.id} className="test-list-item">
          <div>
            <h3>{set.name}</h3>
            <p>Liczba pytań: {set.questions.length}</p>
          </div>
          <Link to={`/test/${set.id}`} className="start-test-button">
            Rozpocznij Test
          </Link>
        </div>
      ))}
    </div>
  );
};